import httpRequest from '../../utils/request';

// Registrar nuevo comercio
const registerTenant = async (tenantData) => {
  const response = await httpRequest.post('/tenants/register', tenantData);
  return response.data;
};

// Verificar disponibilidad de subdominio
const checkSubdomain = async (subdomain) => {
  const response = await httpRequest.get(`/tenants/check-subdomain/${subdomain}`);
  return response.data;
};

// Obtener información del comercio actual
const getTenantInfo = async () => {
  // Evitar caché en navegadores/proxies y forzar estado fresco desde el backend
  const response = await httpRequest.get('/tenants/me', {
    headers: { 'Cache-Control': 'no-cache' },
    params: { _: Date.now() }
  });
  return response.data;
};

// Actualizar información del comercio
const updateTenantInfo = async (data) => {
  const response = await httpRequest.put('/tenants/me', data);
  return response.data;
};

// Actualizar plan de suscripción
const upgradePlan = async (plan) => {
  const response = await httpRequest.put('/tenants/upgrade', { plan });
  return response.data;
};

const tenantService = {
  registerTenant,
  checkSubdomain,
  getTenantInfo,
  updateTenantInfo,
  upgradePlan,
  
};

export default tenantService;
